module.exports = __webpack_public_path__ + "static/shadowheart-mtg_clb-efc22bdcf57bcf6777117430bcff7d98.jpg";